import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomerService } from '../customer.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerTokenGuard {
  constructor(
    private customer: CustomerService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.customer.isLogged) this.router.navigate(['/']);
    return this.customer.isLogged;
  }
}
